import React, {Component} from 'react';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import './SocialButton.css';


let dumbSocialButton = dumbBem('l-social-button');
let SocialButtonWrp = tx(dumbSocialButton)('div');

let IconWrp = tx([{element: 'icon-wrapper'}, dumbSocialButton])('div');
let Text = tx([{element: 'text'}, dumbSocialButton])('div');

export class SocialButton extends Component {
  render() {
    return (
      <SocialButtonWrp
        onClick={this.props.onClick}
        modifier={this.props.modifier}
      >
        <IconWrp>
          <img src={this.props.img} alt=''/>
        </IconWrp>
        <Text>{this.props.text}</Text>
      </SocialButtonWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/login/socialButton/SocialButton.js